module.exports = __webpack_public_path__ + "static/media/Landing Page Banner_Mobile 2x.4f713bb2.jpg";